import { Copy, ExternalLink, MonitorPlay } from "lucide-react";
import { Button, useToast } from "../ui/index.js";

// A single overlay graphic: all three scenes (scoreboard, VAR, lineup) are on one
// page, i.e. a single Browser Source in OBS too. There used to be a popover here
// for choosing among three links — now there is nothing to choose.
const OVERLAY_PATH = "overlay/index.html";

function overlayUrl(slug: string): string {
  return `${window.location.origin}/bundles/livcg/graphics/${OVERLAY_PATH}?slug=${encodeURIComponent(slug)}`;
}

/** ProjectBar "Stream" button — the current project's OBS Browser Source link.
 *  Clicking copies it; the icon next to it opens it in a new window. */
export function StreamLinks({ slug }: { slug: string }) {
  const { toast } = useToast();
  const url = overlayUrl(slug);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      toast({ tone: "success", title: "Havola nusxalandi", description: `/${slug}` });
    } catch {
      toast({ tone: "error", title: "Nusxalab bo'lmadi", description: `/${slug}` });
    }
  };

  return (
    <div className="flex items-center gap-1">
      <Button
        variant="secondary"
        size="md"
        onClick={() => void copy()}
        title={`OBS Browser Source havolasi — nusxalash\n${url}`}
        leadingIcon={<MonitorPlay className="h-3.5 w-3.5" />}
        className="text-ink-muted"
      >
        Stream
        <Copy className="ml-1.5 h-3.5 w-3.5" />
      </Button>
      <Button
        variant="ghost"
        size="sm"
        iconOnly
        onClick={() => window.open(url, "_blank", "noopener")}
        title="Yangi oynada ochish"
        aria-label="Overlay — yangi oynada ochish"
        className="text-ink-muted"
      >
        <ExternalLink className="h-3.5 w-3.5" />
      </Button>
    </div>
  );
}
